import { render, staticRenderFns } from "./SettlementAdjustmentDetail.vue?vue&type=template&id=3677a3ea&"
import script from "./SettlementAdjustmentDetail.vue?vue&type=script&lang=ts&"
export * from "./SettlementAdjustmentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports